export enum CourseTabsEnum {
  Stations = 0,
  Properties = 1,
  Advanced = 2,
  Map = 3, // mobile only
}
